import * as React from "react";
import Section from "../../../components/atoms/Section";
import { SwooshSVG } from "../../JadwalPertandingan/JadwalPertandingan.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { ScheduleCardList, ScheduleTabs } from "./components";
import { useFetchMatches } from "../../../networks";
import { NewFooter } from "../../../components";
import {
  TabsWrapper,
  ContentWrapper,
  InnerContentWrapper,
  PageTitle,
  ScheduleCardWrapper,
  TitleWrapper,
} from "./JadwalPertadingan.styled";
import moment from "moment";
import { usePageContextFunction } from "../../../context/PageContext";
import { ScheduleCardProps } from "./components/Schedule/Schedule";
import StatisticDetail from "./components/StatisticDetail";
import Show from "../FormRegistration/components/Show";
import { EmptyStateWrapper } from "../GalleryDetail/GalleryDetail.styled";
// @ts-ignore
import EmptyState from "../../../components/molecules/v2/TimelineSection/assets/empty-state-mobile.png";
// @ts-ignore
import EmptyStateDesktop from "../../../components/molecules/v2/TimelineSection/assets/empty-state-desktop.png";

const JadwalPertandinganSocPage = () => {
  const { setOpenPopUp: toglePopUp, setCity } = usePageContextFunction();

  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const [activeIndex, setActiveIndex] = React.useState<number>(0);
  const [activeDate, setActiveDate] = React.useState<string>();

  const parseActiveDate = String(moment(activeDate)?.format("YYYY-MM-DD"));

  const {
    data: dataJadwalPertandinganRaw,
    isFetching,
    isRefetching,
  } = useFetchMatches(
    {
      competition_id: process.env.REACT_APP_LAPANGBOLA_COMPETITION_ID,
      start_date: "2024-10-31",
      end_date: "2024-10-31",
    },
    !!activeDate,
  );

  const isFetchingData = isFetching && !isRefetching;

  const dataDateList = ["2024-11-01", "2024-11-02", "2024-11-03"];

  const dataJadwalPertandingan = dataJadwalPertandinganRaw?.data?.data?.data ?? [];

  const handleChangeTab = (index: number) => {
    setActiveIndex(index);
    setActiveDate(dataDateList?.[index]);
  };

  const handleOpenStatisticModal = (data: ScheduleCardProps) => {
    // @ts-ignore
    toglePopUp({
      state: true,
      classNamePopupParent: "!top-0 top-[16px] !bottom-0 inline overflow-y-hidden max-h-screen",
      classNamePopupContent: `md:bg-[#151E29] bg-[#1F2D3D] static max-h-none h-screen rounded-none ${
        isMobileView ? "mt-0" : "mt-[72px]"
      }`,
      classNamePopupContainer:
        "md:bg-[#151E29] bg-[#1F2D3D] shadow-none w-[100vw] p-0 rounded-none",
      closePosition: !isMobileView ? "outside" : "inside",
      iconCloseClassname: "md:top-0 top-[16px] right-[16px] absolute !h-[24px]",
      typePopUp: "custom-children",
      invertCloseColor: true,
      isDisableHandleTouchMove: true,
      children: <StatisticDetail data={data} />,
    });
  };

  React.useEffect(() => {
    const currentDate = moment();
    const activeIndex = dataDateList?.findIndex((data) => {
      const isSameDay = currentDate.isSame(moment(data), "days");

      return isSameDay;
    });

    setActiveIndex(activeIndex ?? 0);

    if (activeIndex >= 0) {
      setActiveDate(String(moment(currentDate)?.format("YYYY-MM-DD")));
    }
  }, []);

  React.useEffect(() => {
    // @ts-ignore
    setCity("soc");
  }, []);

  return (
    <React.Fragment>
      {/* @ts-ignore */}
      <Section id="jadwal-pertandingan" height={"auto"} overflowY={"auto"}>
        <SwooshSVG
          src={func.getStaticImg(
            isMobileView ? "/bg/sharpswoosh-soc-m.svg" : "/bg/sharpswoosh-soc.svg",
          )}
        />
        <ContentWrapper
          style={{
            background: `${"#1F2D3D"} ${`url(${func.getStaticImg(
              "/bg/brush-woosh.svg",
            )})`} center 30% no-repeat`,
          }}
        >
          <InnerContentWrapper>
            <TabsWrapper>
              <TitleWrapper>
                <PageTitle>Jadwal & Hasil Pertandingan</PageTitle>
              </TitleWrapper>
              <div className={isMobileView ? "px-[20px]" : ""}>
                <ScheduleTabs
                  activeIndex={activeIndex}
                  options={[
                    {
                      index: 0,
                      date: "2024-11-01",
                    },
                    {
                      index: 1,
                      date: "2024-11-02",
                    },
                    {
                      index: 2,
                      date: "2024-11-03",
                    },
                  ]}
                  onChangeTab={handleChangeTab}
                />
              </div>
            </TabsWrapper>
            <ScheduleCardWrapper>
              <Show
                when={dataJadwalPertandingan?.length > 0}
                fallbackComponent={
                  <EmptyStateWrapper style={{ left: 0 }}>
                    {isMobileView ? (
                      <img src={EmptyState} alt={"empty-state"} className="h-[484px]" />
                    ) : (
                      <img src={EmptyStateDesktop} alt={"empty-state"} />
                    )}
                  </EmptyStateWrapper>
                }
              >
                <ScheduleCardList
                  isLoading={isFetchingData}
                  onClick={handleOpenStatisticModal}
                  data={dataJadwalPertandingan}
                />
              </Show>
            </ScheduleCardWrapper>
          </InnerContentWrapper>
        </ContentWrapper>
      </Section>
      {/* @ts-ignore */}
      <NewFooter />
    </React.Fragment>
  );
};

export default JadwalPertandinganSocPage;
